module.exports = __webpack_public_path__ + "static/img/3.fa45291b.jpg";